import { Directive, HostListener, Input } from '@angular/core';
import { BehaviorTrackerService } from 'app/behavior-tracking/behavior-tracker.service';

@Directive({
    standalone: true,
    selector: '[trackBehavior]',
})
export class TrackBehaviorDirective {
    @Input('trackBehavior') public eventName!: string;
    @Input() public trackBehaviorData: Record<string, unknown> = {};
    @Input() public trackBehaviorProvider?: string | string[];

    public constructor(private tracker: BehaviorTrackerService) {
    }

    @HostListener('click')
    public handleClick(): void {
        this.tracker.capture(this.eventName, this.trackBehaviorData, this.trackBehaviorProvider);
    }
}
